import txBase, {TO_SAVE_BASE, KEY, initState as baseState} from '../../../vuex/tx-base';
import {registerModule} from '../../../vuex/helpers/vuex-pathify-register-module';
import {sync, make} from 'vuex-pathify'
import templateResetMutation from "../../../vuex/helpers/template-reset-mutation";

import deepmerge from "deepmerge";

const STORE_NAMESPACE = 'city-map';

function isSet(obj, key) {
    return obj && obj[key] !== typeof undefined
}

let mapData = window[KEY];

export const initState = (mapData) => {
    return {
        center: mapData?.center?.map(Number) || [59.32932349999999, 18.0685808],
        zoom: mapData?.zoom || 14,
        lang: mapData?.lang || "sw",

        mapStyle: mapData?.mapStyle || 'city-map',
        country: mapData?.country || 'Sverige',
        city: mapData?.city || 'Stockholm',
    }
}

let vuexModule = {};
vuexModule.state = initState(mapData);

vuexModule.mutations = {
    ...make.mutations(vuexModule.state),
    reset: templateResetMutation(initState, STORE_NAMESPACE)
}

const EXCLUDE_FROM_SAVE = [];

let SAVE_PARAMS = [
    ...TO_SAVE_BASE,
    ...Object.keys(vuexModule.state).filter(item => !!EXCLUDE_FROM_SAVE.findIndex(exclude => item === exclude))
]

let extendedModule = deepmerge(txBase, vuexModule);

function members() {
    const {state} = extendedModule;
    let computed = {};
    for (let [key, value] of Object.entries(state)) {
        computed[key] = sync(`${STORE_NAMESPACE}/${key}`)
    }

    computed.toSaveParams = function () {
        let toSaveParams = {};
        for (let key of SAVE_PARAMS) {
            toSaveParams[key] = this[key]
        }
        return toSaveParams
    };

    return {
        computed,
    }
}


export default CityMapModule => {
    return registerModule(STORE_NAMESPACE, extendedModule, members);
}